import React from 'react';
import Icon from './Icon';

export default function SectionHeader({ title, kicker, action, actionLabel = 'Все' }) {
    return (
        <div style={{
            display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
            padding: '0 16px', marginBottom: 12, gap: 12,
        }}>
            <div style={{ minWidth: 0 }}>
                {kicker && (
                    <div style={{
                        fontFamily: "'JetBrains Mono', monospace",
                        fontSize: 10, color: '#e60073',
                        letterSpacing: 1.2, textTransform: 'uppercase', marginBottom: 4,
                    }}>{kicker}</div>
                )}
                <div style={{ fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: -0.3 }}>
                    {title}
                </div>
            </div>
            {action && (
                <button
                    onClick={action}
                    style={{
                        background: 'transparent', border: 0, color: '#A1A1AA',
                        fontSize: 12, fontWeight: 500, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', gap: 2,
                        padding: '4px 0', whiteSpace: 'nowrap',
                        fontFamily: "'Manrope', sans-serif",
                    }}
                >
                    {actionLabel}
                    <Icon name="chevron-right" size={14} stroke={2} />
                </button>
            )}
        </div>
    );
}
